import type { DataProvider } from "ra-core";

import { getSupabaseClient } from "@/components/atomic-crm/providers/supabase/supabase";
import { toCreateTaskArgs, toUpdateTaskChanges } from "./taskWrites";

const callTaskFunction = async (
  name: "tenax_create_task" | "tenax_update_task",
  args: Record<string, unknown>,
) => {
  const { data, error } = await getSupabaseClient().rpc(name, args);
  if (error) {
    throw new Error(error.message);
  }
  return data;
};

// TENAX: creates and updates of the tasks resource go through the tenax_*
// functions (task 1.2, D-028); every other call is unchanged.
export const withTenaxTasks = <T extends DataProvider>(dataProvider: T): T => ({
  ...dataProvider,
  async create(resource, params) {
    if (resource !== "tasks") {
      return dataProvider.create(resource, params);
    }
    const data = await callTaskFunction(
      "tenax_create_task",
      toCreateTaskArgs(params.data),
    );
    return { data };
  },
  async update(resource, params) {
    if (resource !== "tasks") {
      return dataProvider.update(resource, params);
    }
    const changes = toUpdateTaskChanges(params.data, params.previousData ?? {});
    if (Object.keys(changes).length === 0) {
      return dataProvider.getOne("tasks", { id: params.id });
    }
    const data = await callTaskFunction("tenax_update_task", {
      p_task_id: params.id,
      p_changes: changes,
    });
    return { data };
  },
});
